import { RefObject } from "react";

import cn from "classnames";

import { RichText } from "@/components/richText/richText.component";
import { Search } from "@/components/search/search.component";

import { brown } from "@/app/font";
import { PDP_FORM_CATEGORY, PDP_FORM_SEARCH } from "@/app/blu/shop/constants";
import { GetKitPageAccessoriesQueryResult } from "@/sanity.types";
import { Input } from "@/components/input/input.component";

export const ProductAccessoriesFilter = ({
  formRef,
  accessories,
  response,
}: ProductAccessoriesFilterProps) => {
  const renderAccessoryGroups = () => {
    if (!accessories?.length) return null;
    return accessories.map((item) => {
      // Remove slashes from the URL to use as the value
      const checked = response?.selectedCategory === item.id;
      return (
        <li data-testid="product-accessories-filter-category" key={item.id}>
          <button
            type="button"
            data-testid="product-accessories-filter-category-button"
            aria-current={checked}
            onClick={() => {
              //  Set the category value to focus the selected category
              (
                formRef.current?.elements.namedItem(
                  PDP_FORM_CATEGORY,
                ) as HTMLInputElement
              ).value = item.id;

              // Submit the form to filter the products
              formRef.current?.requestSubmit();
            }}
            className={cn(
              brown.className,
              "hover:text-secondary transition-border button flex border-b-[3px] py-2.5 whitespace-nowrap uppercase duration-300",
              {
                "text-greyscale-strength cursor-pointer border-transparent":
                  !checked,
                "text-secondary border-secondary": checked,
              },
            )}>
            <span
              data-testid="product-accessories-filter-category-label"
              className="px-[10px]">
              {item.name}
            </span>
          </button>

          <Input
            data-testid="product-accessories-filter-category-input"
            aria-label={`Select ${item.name} category`}
            type="radio"
            name={PDP_FORM_CATEGORY}
            id={item.id}
            value={item.id}
            className="hidden px-2.5"
            defaultChecked={checked}
            onClick={() => formRef.current?.requestSubmit()}
          />
        </li>
      );
    });
  };
  return (
    <div
      data-testid="product-accessories-filter"
      className="flex flex-col gap-8">
      <div className="flex flex-col justify-between gap-4 lg:flex-row">
        <ul
          data-testid="product-accessories-filter-fieldset"
          className="hide-scrollbar flex w-full flex-1 items-center gap-6 overflow-x-scroll">
          {renderAccessoryGroups()}
        </ul>
        <Search
          data-testid="product-accessories-filter-search-input"
          id={PDP_FORM_SEARCH}
          name={PDP_FORM_SEARCH}
          placeholder="Find a product"
          defaultValue={response?.search}
          debounce
          onChange={() => formRef.current?.requestSubmit()}
          onReset={() => formRef.current?.requestSubmit()}
        />
      </div>
      <RichText data-testid="product-accessories-filter-category-description">
        {response?.categoryCallout}
      </RichText>
    </div>
  );
};

export type ProductAccessoriesFilterProps = {
  formRef: RefObject<HTMLFormElement | null>;
  accessories?: NonNullable<GetKitPageAccessoriesQueryResult>["accessories"];
  response?: {
    search: string;
    categoryCallout?: any;
    selectedCategory?: string;
  };
};
